import { useMemo } from 'react';
import { usePermission } from './usePermission';
import { INVENTORY_PERMISSIONS } from '../constants/permissions.constants';

/**
 * Permisos granulares del menú Registro de Inventario (inventory-register).
 */
export function useInventoryRegisterPermissions() {
  const canViewMenu = usePermission(INVENTORY_PERMISSIONS.REGISTER.VIEW);
  const canAdd = usePermission(INVENTORY_PERMISSIONS.REGISTER.ADD);
  const canExport = usePermission(INVENTORY_PERMISSIONS.REGISTER.EXPORT);
  const canViewRow = usePermission(INVENTORY_PERMISSIONS.REGISTER.VIEW_ROW);
  const canEdit = usePermission(INVENTORY_PERMISSIONS.REGISTER.EDIT);
  const canCancel = usePermission(INVENTORY_PERMISSIONS.REGISTER.CANCEL);
  const canPrintDetail = usePermission(INVENTORY_PERMISSIONS.REGISTER.PRINT_DETAIL);
  const canLabelPrint = usePermission(INVENTORY_PERMISSIONS.REGISTER.LABEL_PRINT);

  return useMemo(() => {
    return {
      canViewMenu,
      canAdd,
      canExport,
      canViewRow,
      canEdit,
      canCancel,
      canPrintDetail,
      canLabelPrint,
    };
  }, [
    canViewMenu,
    canAdd,
    canExport,
    canViewRow,
    canEdit,
    canCancel,
    canPrintDetail,
    canLabelPrint,
  ]);
}
